module.exports = __webpack_public_path__ + "img/canyuxunshi.21b8fd0d.png";